import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const {
  INPUT,
  DATE,
  DATE_DISABLE_NO_DAY,
  COMBO_BOX,
  TEXT_AREA,
  AUTO_COMPLETE,
  CURRENCY,
  NUMBER,
  DATE_DAY_INPUT,
} = FIELD_TYPE;
const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Họ tên",
    name: "hoTen",
    disable: true,
    rules: [{ required: true, message: "Chưa nhập lấy họ tên" }],
  },
  {
    type: DATE_DISABLE_NO_DAY,
    label: "Từ ngày",
    name: "tu_ngay",
    disable: false,
    rules: [{ required: true, message: "Chọn ngày bắt đầu" }],
    // optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
    disableDate: false,
  },
  {
    type: DATE_DISABLE_NO_DAY,
    label: "Đến ngày",
    name: "den_ngay",
    disableDate: false,
    disable: false,
    // rules: [{required: true, message: "Chưa nhập ngày hết hiệu lực"}],
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
  {
    type: COMBO_BOX,
    label: "Phòng ban",
    name: "id_phong_ban",
    disable: false,
    rules: [{ required: true, message: "Chưa nhập phòng ban" }],
  },
  {
    type: COMBO_BOX,
    label: "Chức vụ",
    name: "id_chuc_vu",
    rules: [{ required: true, message: "Chưa nhập chức vụ" }],
  },
  {
    type: COMBO_BOX,
    label: "Loại hợp đồng",
    name: "id_loai_hop_dong",
    disable: false,
    rules: [{ required: true, message: "Chưa nhập loại hợp đồng" }],
    // options: [
    //   { value: "Khám bệnh", label: "Khám bệnh" },
    //   { value: "Kỹ thuật viên chụp x-quang", label: "Kỹ thuật viên chụp x-quang" },
    // ],
  },
  {
    type: TEXT_AREA,
    label: "Ghi chú",
    css: {
      xl: 16,
      lg: 12,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 8, xl: 3 },
    wrapperCol: { xs: 14, md: 16, lg: 16, xl: 21 },
    name: "ghiChu",
    disable: false,
  },
];
export { dataFields };
